import { useState } from "react";
import { type ReportTable, downloadCsv, downloadXlsx } from "./exportReport";
import { Button } from "./ui";

/** Excel and CSV download buttons for a report. */
export function ExportButtons({ name, tables }: { name: string; tables: () => ReportTable[] }) {
  const [busy, setBusy] = useState(false);
  return (
    <>
      <Button
        variant="secondary"
        busy={busy}
        onClick={async () => {
          setBusy(true);
          try {
            await downloadXlsx(name, tables());
          } finally {
            setBusy(false);
          }
        }}
      >
        Excel
      </Button>
      <Button variant="quiet" onClick={() => downloadCsv(name, tables())}>
        CSV
      </Button>
    </>
  );
}
